import axios from 'axios';
import {
  GetMessagesQuery,
  GetMessagesResponse,
  GetThreadResponse,
  ReplyMessageRequest,
  ReplyMessageResponse,
} from '../types/message-reply';

export const messageReplyService = {
  // メッセージ一覧取得
  getMessages: async (
    query: GetMessagesQuery = {}
  ): Promise<GetMessagesResponse> => {
    const params = new URLSearchParams();

    if (query.status?.length) {
      query.status.forEach((status) => params.append('status', status));
    }
    if (query.priority?.length) {
      query.priority.forEach((priority) => params.append('priority', priority));
    }
    if (query.company_ids?.length) {
      query.company_ids.forEach((id) =>
        params.append('company_ids', id.toString())
      );
    }
    if (query.has_keyword) {
      params.append('has_keyword', query.has_keyword);
    }
    if (query.is_starred !== undefined) {
      params.append('is_starred', query.is_starred.toString());
    }
    if (query.is_archived !== undefined) {
      params.append('is_archived', query.is_archived.toString());
    }
    if (query.tags?.length) {
      query.tags.forEach((tag) => params.append('tags', tag));
    }
    if (query.page) {
      params.append('page', query.page.toString());
    }
    if (query.limit) {
      params.append('limit', query.limit.toString());
    }
    if (query.sort) {
      params.append('sort', query.sort);
    }
    if (query.order) {
      params.append('order', query.order);
    }

    const response = await axios.get(`/api/messages?${params.toString()}`, {
      withCredentials: true,
    });
    return response.data;
  },

  // メッセージ詳細取得
  getMessageDetail: async (messageId: string): Promise<GetThreadResponse> => {
    const response = await axios.get(`/api/messages/${messageId}`, {
      withCredentials: true,
    });
    return response.data;
  },

  // メッセージ返信
  replyToMessage: async (
    messageId: string,
    replyData: ReplyMessageRequest
  ): Promise<ReplyMessageResponse> => {
    const response = await axios.post(
      `/api/messages/${messageId}/reply`,
      replyData,
      {
        withCredentials: true,
      }
    );
    return response.data;
  },

  // 既読マーク
  markAsRead: async (messageId: string) => {
    const response = await axios.put(
      `/api/messages/${messageId}/read`,
      {},
      {
        withCredentials: true,
      }
    );
    return response.data;
  },

  // 返信テンプレート機能は削除されました
};
